<template>
  <o-view class="c-view--poi" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        :has-back-button="true"
        :is-centered="true"
        :is-extended="true"
        logo="brands/bluebike"
      >
        <template slot="right">
          <o-icon icon="favorite" v-if="$store.state.showFavoriteButton" />
        </template>
      </o-nav-bar>
      <o-section :is-transparent="true">
        <o-prominents :items="prominentItems" />
      </o-section>
      <div class="c-view--poi-sections">
        <o-section> <h2 class="c-poi-title">Fietspunt Deinze</h2> </o-section>
        <o-section>
          <p>
            De toegang tot de fietsenstalling is op niveau -2 van het station.
            Er is een herstelpunt ter plaatse dat geopend is van 9u00 tot 16u00.
          </p>
        </o-section>
        <o-section>
          <o-key-value label="Adres" value="Oktrooiplein 10, 9000 Gent" />
        </o-section>
        <o-section> <o-key-value label="Key" value="Value" /> </o-section>
        <o-section> <o-key-value label="Key" value="Value" /> </o-section>
      </div>
    </o-view>
    <o-pay-button label="Koop ticket" to="/sales/bike/bluebike" />
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
import OProminents from '@/components/OProminents.vue'
export default {
  name: 'POIBluebike',
  components: {
    OPayButton,
    OProminents
  },
  data() {
    return {
      prominentItems: [
        {
          key: 'Beschikbare fietsen',
          value: '12'
        },
        {
          key: 'Totaal aantal fietsen',
          value: '16'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.c-view--poi {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .c-view--poi-sections {
    flex: 1 0 auto;
  }
}

.c-poi-title {
  font-weight: 600;
  text-align: center;
}
</style>
